import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor() { }

 // public user: string;
 // public pass: string;
 // public nome: string;
  // Utilizado para Debug e para o build para Browser (true = browser / false = mobile)
  public debugMode = false;
  public loginList: any;
 // public dominio: string;
  //public plano;
  //public comandaMesa: string;
 //// public loja: string;
 // public impressao_tipo: string;
 // public impressao_tamanho: string;
  //public senha_adm: string;
  //public labelEncomenda: string;



  
  public get user(): string {
    return localStorage.getItem('user') ?? '';
  }

  public get pass(): string {
    return localStorage.getItem('pass') ?? '';
  }

  public get nome(): string {
    return localStorage.getItem('nome') ?? '';
  }

  public get plano(): string {
    return localStorage.getItem('plano') ?? '';
  }

  public get impressao_tamanho(): string {
    return localStorage.getItem('impressao_tamanho') ?? '';
  }

  public get impressao_tipo(): string {
    return localStorage.getItem('impressao_tipo') ?? '';
  }

  public get comandaMesa(): string {
    return localStorage.getItem('comandaMesa') ?? '';
  }

  public get dominio(): string {
    return localStorage.getItem('dominio') ?? '';
  }

  public get loja(): string {
    return localStorage.getItem('loja') ?? '';
  }

  public get senha_adm(): string {
    return localStorage.getItem('senha_adm') ?? '';
  }

  public get authToken(): string {
    return localStorage.getItem('authToken') ?? '';
  }

  public get labelEncomenda(): string {
    return localStorage.getItem('labelEncomenda') ?? '';
  }

}
